var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEnabling = function SvgEnabling(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    stroke: "#95C842",
    strokeWidth: 2,
    d: "M20,2 M20,2c9.9,0,18,8.1,18,18 M29,13.5L17.8,26.3L11,19.1 M17.9,2.1C18.6,2,19.3,2,20,2 M10.7,4.6 c1.1-0.7,2.3-1.2,3.6-1.7 M5.1,9.9c0.8-1.1,1.6-2.1,2.6-3 M2.2,17c0.2-1.4,0.6-2.7,1.2-4 M2.6,24.6C2.3,23.3,2,21.9,2,20.5  M6.1,31.4c-0.9-1.1-1.7-2.3-2.3-3.6 M12.1,36.2c-1.3-0.6-2.5-1.4-3.6-2.3 M19.4,38c-1.4,0-2.8-0.3-4.1-0.6 M26.9,36.6 c-1.2,0.5-2.5,0.9-3.9,1.1 M33.3,32.1c-1,1.1-2.1,2-3.2,2.8 M37.2,25.4c-0.4,1.4-1,2.7-1.8,3.9 M38,20c0,0.7,0,1.4-0.1,2.1 M11,19.1 "
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEnabling);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/enabling.faa8b985ffab2c48730a5f805c3d9382.svg";